import { Solicitation } from "../card-solicitation";

export class CardDataResponse {
    constructor() {
        this.activeCards = 0;
        this.inventoryCards = 0;
        this.pendingCards = 0;
        this.inProcessingCards = 0;
        this.inAnalysisCards = 0;
    }

    activeCards: number;
    inventoryCards: number;
    pendingCards: number;
    inProcessingCards: number;
    inAnalysisCards: number;
}

export class CardsLimitsResponse {
    constructor() {}

    collaboratorsWithCard: number;
    collaboratorsWithoutCard: number;
    quantityPersonInventory: number;
    cardsAdditionValue: number;
    solicitedCards: number;
    cardsLimit: number;
}

export class SolicitationResponse {
    constructor() { }

    totalSolicitations: number;
    solicitations: Solicitation[];
}

export class SolicitCardResponse {
    constructor() { }

    cardSolicitationId: number;
    quantityCards: number;
    statusId: number;
    solicitationDate: Date;
}
export class CollaboratorWithoutCardResponse {
    constructor() { }

    totalCollaborators: number;
    collaborators: Collaborators[];
}
export class Collaborators {
    selected: boolean;
    useAddress: boolean;
    id: number;
    collaboratorId: number;
    collaboratorName: string
    collaboratorDocument: string;
    collaboratorHasAddress: boolean;
}
export class SolicitationDetailResponse {
    solicitationId: number;
    statusId: number;
    statusDescription: string;
    quantityCards: number;
    solicitationDate: Date;
    deliveryDate: Date;
    solicitationItems: SolicitationItems[];
}
export class SolicitationItems {
    solicitationItemId: number;
    solicitationId: number;
    statusId: number;
    statusDescription: string;
    quantityCards: number;
    personId: number;
    collaboratorId: number;
    collaboratorName: string;
    backOfficeUserId: number;
    solicitationDate: Date;
    deliveryDate: Date;
    trackingCode: string;
    receiverName: string;
    deliveryAddressId: number;
}

export class SolicitationItemAddressResponse {
    cep: number;
    address: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    uf: string;
}
